import React, { memo, useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
// Import logo from assets directory
import Wyenfos_bills_logo from '../../assets/company-logos/Wyenfosbills_logo.png';

const Header = memo(() => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const headerRef = useRef(null);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (headerRef.current && !headerRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setIsMobileMenuOpen(false);
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscapeKey);
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  return (
    <header className="mainpage-header-container" role="banner" ref={headerRef}>
      <div className="mainpage-logo-title-container">
        <div className="mainpage-logo-container">
          <img 
            src={Wyenfos_bills_logo} 
            alt="WyenFos Bills - Company Logo" 
            className="mainpage-header-logo"
            loading="lazy"
            onLoad={(e) => {
              console.log('Logo loaded successfully:', Wyenfos_bills_logo);
              console.log('Image dimensions:', e.target.naturalWidth, 'x', e.target.naturalHeight);
              console.log('Image display size:', e.target.offsetWidth, 'x', e.target.offsetHeight);
            }}
            onError={(e) => {
              console.error('Logo failed to load:', Wyenfos_bills_logo);
              console.error('Error details:', e);
              // Show a fallback text instead of hiding
              e.target.style.display = 'none';
              const fallback = document.createElement('div');
              fallback.className = 'mainpage-logo-fallback';
              fallback.textContent = 'W';
              fallback.style.cssText = `
                width: 50px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 24px;
                font-weight: bold;
                color: #764ba2;
                background-color: white;
                border-radius: 8px;
                border: 2px solid #764ba2;
              `;
              e.target.parentNode.insertBefore(fallback, e.target);
            }}
          />
        </div>
        <h1 className="mainpage-header-title">WYENFOS BILLS</h1>
      </div>

      <button 
        className="mainpage-mobile-menu-button"
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={isMobileMenuOpen}
        aria-controls="auth-navigation"
      >
        <span className="mainpage-hamburger-line"></span>
        <span className="mainpage-hamburger-line"></span>
        <span className="mainpage-hamburger-line"></span>
      </button>

      <nav 
        id="auth-navigation"
        className={`mainpage-auth-buttons ${isMobileMenuOpen ? 'mainpage-mobile-open' : ''}`}
        role="navigation" 
        aria-label="Authentication navigation"
      >
        <Link 
          to="/register" 
          className="mainpage-auth-button"
          aria-label="Register for a new account"
          onClick={closeMobileMenu}
        >
          Register
        </Link>
        <Link 
          to="/login" 
          className="mainpage-auth-button"
          aria-label="Login to your account"
          onClick={closeMobileMenu}
        >
          Login
        </Link>
      </nav>
    </header>
  );
});

Header.displayName = 'Header';
export default Header;
